import React, { FC } from 'react'
import styles from './GridPosts.module.scss'
import SALink from 'components/SALink'
import { capitalizeString, displayEllipticalString, truncateTextWithEllipsis } from 'lib/helpers'
import classNames from 'classnames'
import useQA from 'hooks/useQA'
import { useSelector } from 'react-redux'
import { getIsMobileScreenWidth } from 'selectors/screen'

const MAX_LENGTH = 65

type GridPostsDataItem = {
  image: string
  title: string
  linkTitle?: string
  linkUrl: string
  description?: string
}

type GridPostsProps = {
  data: ReadonlyArray<GridPostsDataItem>
  title: string
  link?: string
  linkTitle?: string
}

const TITLE_CLASSNAME = {
  [0]: styles.itemLarge,
  [1]: styles.item1,
  [2]: styles.item2,
}

const GridPosts: FC<GridPostsProps> = ({ data, title, link, linkTitle }) => {
  const { testId } = useQA()
  const isMobile = useSelector(getIsMobileScreenWidth)

  return (
    <div className={styles.gridLayout} {...testId('grid-layout')}>
      <div className={styles.headerSection}>
        <h4 className={styles.title}>{title}</h4>
        <SALink href={link} title={linkTitle} className={styles.link}>
          <p className={styles.linkTitle}>{linkTitle}</p>
        </SALink>
      </div>
      <div className={styles.grid} {...testId('grid')}>
        {data.map((item, index) => {
          return (
            <SALink
              key={index}
              href={item.linkUrl}
              title={capitalizeString(item.title)}
              className={classNames(
                {
                  [styles.itemSideBySide]: index === 1 || index === 2,
                },
                TITLE_CLASSNAME[index] || styles.itemRegular
              )}
            >
              <img src={item.image} className={styles.gridImage} />
              <div className={styles.titleSection}>
                <h6 className={styles.title}>{displayEllipticalString(item.title, MAX_LENGTH)}</h6>
                <p className={styles.description}>
                  {isMobile
                    ? truncateTextWithEllipsis(item.description, 77)
                    : truncateTextWithEllipsis(item.description, 147)}
                </p>
                <p className={styles.link}>{item.linkTitle}</p>
              </div>
            </SALink>
          )
        })}
      </div>
    </div>
  )
}

export default GridPosts
